import { Node } from 'data/types'
import React from 'react'

import ExtraQuestionInput from './ExtraQuestion'

type Props = {
  node: Node
  onChange: (option: Node) => void
}
const ExtraQuestions = ({ node, onChange }: Props) => {
  if (node.type !== 'SELECTION' || !node.children || node.children.length === 0) return null

  // stop propagation or click bubbled and toogles off selected node
  return (
    <div onClick={(e) => e.stopPropagation()}>
      {node.children.map((extra) => (
        <ExtraQuestionInput
          key={extra.id}
          question={extra}
          onChange={(input) =>
            onChange({
              ...node,
              children: node.children?.map((c) => {
                if (c.id !== extra.id) return c
                return {
                  ...c,
                  input
                }
              })
            })
          }
        />
      ))}
    </div>
  )
}

export default ExtraQuestions
